<template>
    <div class="wrap-history">
        <div class="wrap-content">
            <div class="title-page">History</div>
            <section class="content">
                <div class="wrap-realitation">
                    <div class="realitation">
                        <span>Series No</span>
                        <span>{{ getRealitation.seri }}</span>
                    </div>
                    <div class="realitation">
                        <span>HS Code</span>
                        <span>{{ getRealitation.hs }}</span>
                    </div>
                    <div class="realitation">
                        <span>Permission Id</span>
                        <span>{{ getRealitation.id_ijin }}</span>
                    </div>
                    <div class="realitation">
                        <span>Destination Code</span>
                        <span>{{ getRealitation.pelabuhan_tujuan }}</span>
                    </div>
                    <div class="realitation">
                        <span>Original State</span>
                        <span>{{ getRealitation.negara_asal }}</span>
                    </div>
                    <div class="realitation">
                        <span>Volume</span>
                        <span v-if="getRealitation.volume">{{ getRealitation.volume.total }}</span>
                    </div>
                    <div class="realitation">
                        <span>Remaining Volume</span>
                        <span v-if="getRealitation.volume">{{ getRealitation.volume.sisa.toFixed(5) }}</span>
                    </div>
                    <div class="realitation">
                        <span>Unit</span>
                        <span>{{ getRealitation.satuan_terkecil }}</span>
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Volume</th>
                            <th>Amount</th>
                            <th>Total Amount</th>
                            <th>Realization Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(history, i) in getHistory" :key="i">
                            <td>{{ i + 1 }}</td>
                            <td>{{ history.realisasi.volume.toFixed(5) }}</td>
                            <td>{{ "Rp " + formatCurency(history.realisasi.nilai) }}</td>
                            <td>{{ "Rp " + formatCurency(history.realisasi.total_harga) }}</td>
                            <td>{{ history.realisasi.date | formatDate }}</td>
                            <td>
                                <!-- <router-link :to="'/permission-detail/' + id_ijin + '/history-detail/' + history._id"> -->
                                <b-button variant="outline-info" size="sm" class="mb-1" @click="openModal(history._id)"> Detail </b-button>
                                <!-- </router-link> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="d-flex justify-content-end mt-3">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="getTotalHistory"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="getTotalHistory > 10"
                    ></b-pagination>
                </div>
            </section>
        </div>
        <b-modal ref="modal-detail" title="Detail History" size="xl">
            <permission-history-detail
                :setDataHistory="getDetailHistory"
                :setTotalDetailHistory="getTotalDetailHistory"
                @changePage="setChangePageDetailHistory"
            ></permission-history-detail>
        </b-modal>
    </div>
</template>

<script>
import PermissionHistoryDetail from "./PermissionHistoryDetail.vue";
export default {
    components: { PermissionHistoryDetail },
    data() {
        return {
            startDate: "",
            endDate: "",
            currentPage: 1,
            perPage: 10,
            id_ijin: "",
            idRealisation: Number(),
            id_history: "",
        };
    },
    mounted() {
        this.idRealisation = this.$route.params.realisation_id;
        this.id_ijin = this.$route.params.id;
        this.$store.dispatch("getHistoryRealitation", { realisation_id: this.idRealisation, currentPage: this.currentPage, perPage: this.perPage });
    },
    computed: {
        getHistory() {
            return this.$store.state.vaultModul.dataHistory.data;
        },
        getTotalHistory() {
            return this.$store.state.vaultModul.dataHistory.count;
        },
        getRealitation() {
            return this.$store.state.vaultModul.dataHistory.realisasi;
        },
        setIdHistory() {
            return this.id_history;
        },
        getDetailHistory() {
            return this.$store.state.vaultModul.dataDetailHistory.data;
        },
        getTotalDetailHistory() {
            return this.$store.state.vaultModul.dataDetailHistory.count;
        },
    },
    methods: {
        checkDecimal(value) {
            if (Number.isInteger(value)) {
                return value;
            } else {
                let lengthDecimal = value.toString().split(".")[1].length;
                let newValue;
                if (lengthDecimal > 5) {
                    newValue = value.toFixed(5);
                } else {
                    newValue = value;
                }
                return newValue;
            }
        },
        formatCurency(value) {
            let pounds = Intl.NumberFormat("en-US");
            return pounds.format(value);

            // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        handlePageChange(value) {
            this.$store.dispatch("getHistoryRealitation", { realisation_id: this.idRealisation, currentPage: value, perPage: this.perPage });
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        openModal(idHistory) {
            this.$refs["modal-detail"].show();
            this.id_history = idHistory;
            const HcurrentPage = 1;
            const HperPage = 10;
            this.$store.dispatch("getHistoryDetailRealitation", { history_id: this.id_history, currentPage: HcurrentPage, perPage: HperPage });
        },
        setChangePageDetailHistory(valueChangePage) {
            this.$store.dispatch("getHistoryDetailRealitation", {
                history_id: this.id_history,
                currentPage: valueChangePage.currentPage,
                perPage: valueChangePage.perPage,
            });
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.wrap-realitation {
    margin-bottom: 2rem;
}

.realitation {
    display: flex;
    margin-bottom: 0.5rem;
}

.realitation span:first-child {
    width: 9rem;
}
.realitation span:last-child {
    font-weight: 600;
}
</style>
